import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationOptions } from '@react-navigation/native-stack';
import { useLayoutEffect, DependencyList } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Sets navigation options on useLayoutEffect
 * @param {NativeStackNavigationOptions} options - All the options to be passed to the navigation
 * @param {DependencyList} deps - Dependencies to be tracked in useLayoutEffect
 */
export function useNavOptionsSet(
  options: NativeStackNavigationOptions,
  deps: DependencyList = [],
) {
  const nav = useNavigation();
  const { i18n } = useTranslation();

  useLayoutEffect(() => {
    nav.setOptions(options);
  }, [i18n.language, ...deps]);
}
